import { Link } from "react-router-dom";
import Seo from "../components/Seo";

export default function NotFound() {
  return (
    <section className="grid min-h-[60vh] place-items-center px-5 py-24" data-testid="page-404">
      <Seo title="Pagina non trovata" path="/404" />
      <div className="text-center">
        <p className="eyebrow">Errore 404</p>
        <h1 className="mt-4 font-display text-3xl font-extrabold tracking-tight text-antracite sm:text-4xl">
          Pagina non trovata
        </h1>
        <p className="mt-3 text-sm text-muted">La pagina che cerchi non esiste o è stata spostata.</p>
        <Link to="/" data-testid="cta-404-home" className="btn-primary mt-8">
          Torna alla home
        </Link>
      </div>
    </section>
  );
}
